module.exports = __webpack_public_path__ + "static/media/syw-favicon.1e7811d6.ico";